import React, { useCallback } from "react";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../../styles/theme";
import { bannerStyles } from "./Banner";

import javascriptHandler from "../../apis/javascriptHandler";
import FaqBg from "../../assets/faq-bg@2x.png";
import Caption from "./Caption";

interface Props {}

const useStyles = createUseStyles((theme: ThemeType) => ({
   banner: (props: Props) => ({
      ...bannerStyles,
      height: 170,
      background: `url(${FaqBg}) bottom right no-repeat`,
      backgroundSize: "50% auto",
   }),
}));

const FaqBanner: React.FC<Props> = (props) => {
   const classes = useStyles(props);
   const handleClick = useCallback(() => {
      // javascriptHandler.openWebView("faq");
      javascriptHandler._callHandler("OpenWebView", "faq");
   }, []);

   return (
      <div className={classes.banner} onClick={() => handleClick()}>
         <Caption
            item={{
               subTitle: "궁금하신 점은 여기서 해결하세요",
               title: "자주 묻는 질문",
               reverseColor: true,
            }}
            isGuideDetailPage={false}
         />
      </div>
   );
};

export default FaqBanner;
